export enum I18dateRange {
    CUSTOM = 'timeGroup.custom',
    TODAY = 'timeGroup.today',
    YESTERDAY = 'timeGroup.yesterday',
    LAST_7_DAYS = 'timeGroup.7days',
    LAST_30_DAYS = 'timeGroup.30days',
    THIS_WEEK = 'timeGroup.thisWeek',
    THIS_MONTH = 'timeGroup.thisMonth',
    THIS_QUARTER = 'timeGroup.thisQuarter',
    THIS_YEAR = 'timeGroup.thisYear',
    LAST_WEEK = 'timeGroup.lastWeek',
    LAST_MONTH = 'timeGroup.lastMonth',
    LAST_QUARTER = 'timeGroup.lastQuarter',
    LAST_YEAR = 'timeGroup.lastYear'
}